/**
 * Run results screen — shown on death or victory. Summarizes the run's stats +
 * lifetime meta, offers a seed share string, and returns to the title.
 */

import { el, div, button } from "../dom";
import { dominantArchetype } from "../store";
import type { Store } from "../store";

export function renderResults(store: Store): HTMLElement {
  const run = store.run;
  const meta = store.meta;
  const won = run?.phase === "victory";

  const screen = div("screen");
  const body = div("screen__body scroll");
  body.style.alignItems = "center";
  body.style.justifyContent = "center";

  body.appendChild(
    el("div", {
      class: "logo",
      html: won ? "BREACH <span class=\"z\">COMPLETE</span>" : "FLATLINE",
      style: won ? "" : "color:var(--red);font-size:52px",
    }),
  );
  body.appendChild(
    el("div", {
      class: "muted center",
      text: won
        ? "You cracked the Core. The net remembers your name."
        : "Your signal was traced and severed. The run ends here.",
      style: "max-width:480px;white-space:normal;line-height:1.5",
    }),
  );

  if (run) {
    const arch = dominantArchetype(run);
    const stats = run.stats;
    const panel = div("panel");
    panel.style.width = "440px";
    const grid = div("grid2");
    const add = (k: string, v: string | number) =>
      grid.appendChild(
        div("statline", [
          el("span", { class: "k", text: k }),
          el("span", { class: "v", text: String(v) }),
        ]),
      );
    add("Result", won ? "VICTORY" : "DEATH");
    add("Floor", run.floor);
    add("Act reached", run.map.act);
    add("Heat", run.heat);
    add("Turns", stats.turnsTaken);
    add("ICE killed", stats.enemiesKilled);
    add("Elites", stats.elitesKilled);
    add("Damage dealt", stats.damageDealt);
    add("Damage taken", stats.damageTaken);
    add("Max Trace", stats.maxTraceReached);
    add("Archetype", arch ?? "—");
    add("Deck size", run.deck.length);
    panel.appendChild(grid);
    body.appendChild(panel);

    body.appendChild(
      el("div", {
        class: "muted center",
        text: `SEED ${run.seed} · ${run.character.toUpperCase()} · share to replay`,
        style: "letter-spacing:1px",
      }),
    );
  }

  // Lifetime line.
  body.appendChild(
    el("div", {
      class: "muted center",
      text: `Lifetime: ${meta.stats.runsWon}W / ${meta.stats.deaths}L · best floor ${meta.stats.bestFloor}`,
    }),
  );

  screen.appendChild(body);

  const actions = div("row");
  actions.style.justifyContent = "center";
  actions.appendChild(
    button("btn btn--primary", "◀ MAIN MENU", () => store.closeResults()),
  );
  screen.appendChild(actions);
  return screen;
}
